'use client'

import React from 'react'
import Image from 'next/image'
// import placeholderImage from '@/public/images/landingCardPlaceholder.png'
// import placeholderImage from '@/public/images/authloginsignup.png'
import signupImage from '@/public/images/SignUp.png'
import signinImage from '@/public/images/SignIn.png'
import { usePathname, useSearchParams } from 'next/navigation'
import InviteRightSide from '@/components/pages/auth/InviteRightSide'
import Link from 'next/link'

// import Title from '@/components/ui/Title'
// import Header from '@/components/shared/Header/Header'

export default function AuthLayout({
  children
}: Readonly<{
  children: React.ReactNode
}>) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const isSignup = pathname.includes('/signup')
  const isPasswordRecovery = pathname.includes('/password-recovery')
  const isInviteMembers = pathname.includes('/invite-members')
  const isPricing = pathname.includes('/pricing')
  const isPaymentCheckout = pathname.includes('/payment-checkout')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const hasOtpParam = searchParams.get('step') === 'otp'

  const overlayText = {
    title: 'Experience the Future of marketing with Waltz-AI',
    subtitle:
      'Unlock the power of AI-driven marketing with Waltz-AI. Create and optimize landing pages that boost conversions and personalize content based on real-time user insights. Say goodbye to guesswork and take your marketing to the next level—faster, smarter, and more effective'
  }

  const showRightPanel =
    !isPasswordRecovery && !isInviteMembers && !isPricing && !isPaymentCheckout

  return (
    <div className='flex min-h-screen flex-col'>
      {/* Mobile and Tablet Navbar */}
      <nav className='fixed top-0 left-0 right-0 z-[1000] bg-white border-b border-gray-100 shadow-sm lg:hidden'>
        <div className='h-16 flex items-center justify-between px-6'>
          <div className='flex items-center'>
            <Link href='/' className='flex items-center'>
              <Image
                src='/images/waltzLogoSm.svg'
                alt='Waltz AI'
                width={48}
                height={24}
                className='h-[24px] w-[48px] flex-shrink-0 md:hidden'
                style={{ objectFit: 'contain' }}
                priority
              />
              <Image
                src='/images/waltzlogo.svg'
                alt='Waltz AI'
                width={145.5}
                height={23}
                className='hidden md:block h-[23px] w-[145.5px] flex-shrink-0'
                style={{ objectFit: 'contain' }}
                priority
              />
            </Link>
          </div>
        </div>
      </nav>

      <div className='flex min-h-screen w-full'>
        {/* Desktop Logo - positioned absolute */}
        <div className={`hidden lg:flex fixed mb-6 mt-6 z-10 items-center justify-start gap-2 ${
            isPaymentCheckout ? 'sm:ml-[100px] ml-[31px]' : 'sm:ml-16 ml-[31px]'}`}>
          <Link href='/' className='flex items-center'>
            <Image
              src='/images/waltzlogo.svg'
              alt='Waltz AI'
              width={145.5}
              height={23}
              className='h-[23px] w-[145.5px] flex-shrink-0'
              style={{ objectFit: 'contain' }}
              priority
            />
          </Link>
        </div>
        
        <div
          className={`hide-scrollbar flex h-screen flex-1 items-start justify-center overflow-x-auto ${
            isPaymentCheckout ? '' : 'pb-[60px] pt-[75px] '
          }`}
        >
          {children}
        </div>
        {showRightPanel && (
          <div className='relative hidden h-screen w-[40%] lg:block'>
            {isInviteMembers ? (
              <InviteRightSide />
            ) : (
              <>
                <Image
                  src={isSignup ? signupImage.src : signinImage.src}
                  alt='Experience the Future of marketing with Waltz-AI'
                  className='!static'
                  fill
                  sizes='(max-width: 1024px) 100vw'
                  priority
                />
                <div className='absolute inset-0 flex flex-col justify-end bg-black/30 px-12 pb-20 text-white'>
                  <h2 className='font-figtree mb-4 text-[40px] font-semibold leading-[48px]'>
                    {overlayText.title}
                  </h2>
                  <p className='font-inter text-base font-normal leading-6'>
                    {overlayText.subtitle}
                  </p>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
